import React, { useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { createFolder,updateFolder } from '../../../api/api';

const AddFolderModal = ({ isOpen, onClose, main, project_id, update,editing,folderDetails }) => {
  console.log(editing,folderDetails)
  const [folderName, setFolderName] = useState('');
  const [path, setPath] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Populate folder name if in editing mode
  useEffect(() => {
    if (editing && folderDetails) {
      setFolderName(folderDetails.name || '');
    } else {
      setFolderName('');
    }
  }, [editing, folderDetails]);

  const handleFolderNameChange = (e) => setFolderName(e.target.value);
  const handleCreateFolder = async (e) => {
    e.preventDefault();
    const folderPath = `${main.replace('\\', '/')}/${folderName}`;
    setError(''); // Clear any previous errors
    setLoading(true); // Start loading state
    try {
      if(editing){
        const data={
          projectId:project_id,
          folder_path:`${main}`,
          old_name:folderDetails.name,
          new_name:folderName

        }
        console.log(data)
        const res = await updateFolder(data);
        console.log(res.data);
      
      }else{
        const res = await createFolder(folderPath, project_id);
        console.log(res.data);
      }
     
      update();
      onClose();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to create folder. Please try again.');
    } finally {
      setLoading(false); // Stop loading state
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-semibold text-gray-900 mb-4">
                  {update?'Rename':'Add'} Folder
                </Dialog.Title>
                <form onSubmit={handleCreateFolder} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Folder Name</label>
                    <input
                      type="text"
                      value={folderName}
                      onChange={handleFolderNameChange}
                      className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>

                  {error && <p className="text-sm text-red-600">{error}</p>}

                  <div className="flex justify-end space-x-3">
                    <button
                      type="button"
                      onClick={onClose}
                      className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md"
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className={`px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md ${
                        loading ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                      disabled={loading}
                    >
                      {loading ? 'Saving...' : 'Save'}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AddFolderModal;
